import { useFormikContext } from "formik";
import React, { useContext, useEffect, useState } from "react";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import { SessionKeyEnum } from "../../../Enumeration/SessionKeyEnum";
import { VideoKYCStatusEnum } from "../../../Enumeration/VideoKYCStatusEnum";
import {VideoKycErrorTypeEnum} from "../../../Enumeration/VideoKycErrorTypeEnum";
import { WidgetEnum } from "../../../Store/WidgetEnum";
import { VIEW_MODE } from "../../../Utils/GlobalValues";
import CsplAccordion from "../../CsplControls/CsplAccordion/CsplAccordion";
import CsplCard from "../../CsplControls/CsplCard/CsplCard";
import CsplLabel from "../../CsplControls/CsplLabel/CsplLabel";
import CsplBackDropLoading from "../../CsplControls/CsplLoader/CsplBackDropLoading";
import CsplVideoComponent from "../../CsplControls/CsplVideoComponent/CsplVideoComponent";
import styles from "../VideoKyc/VideoKyc.module.css";
import FaceCheckComponent from "./FaceCheckComponent";
import AlertModal from "../../CsplModal/AlertModal";
import { StylePropertiesEnum } from "../../../Enumeration/StylePropertiesEnum";
import { useTranslation } from "react-i18next";
import VideoKycResource from "../../Resources/VideoKycResource/VideoKycResource";

function VideoKyc(props) {
  const { values } = useFormikContext();
  const { t } = useTranslation("common");
  const [videoKycCreateProfile,videoKycProfileStatus,updateWidgetStatus,validateDateForVideoKyc,removePersonalInfoData] = VideoKycResource();
  const [clicked, setClicked] = useState(false);
  const [showVideoKycLink, setShowVideoKycLink] = useState(true);
  const applicationContext = useContext(KycApplicationContext);
  const [reviewerStatus, setReviwerStatus] = useState("");
  const [profileStatusClicked,setProfileStatusClicked]  = useState(false);
  const [videoKYCDTO,setVideoKYCDTO]  = useState(values.videoKycDTO);
  const [isOpenAlertMsg,setIsOpenAlertMsg] = useState(false);
  const [alertMsg,setAlertMsg] = useState("");

  let formMode = applicationContext.mode;
  
  function openVideoKyc(url) {
    const newWindow = window.open(url, "_self", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  }
  const [videoKycUrl, setVideoKycUrl] = useState("");
  let isDisabled = applicationContext.disableForm;

  useEffect(() => {
    setVideoKycUrl(values.videoKycDTO.url);

    if (
      values.videoKycDTO.applicationStatus && values.videoKycDTO.applicationStatus.toLowerCase() ===
      VideoKYCStatusEnum.Verified.toLowerCase() 
    ) {
      setShowVideoKycLink(false);
    }

    if (
      values.videoKycDTO &&
      values.videoKycDTO.applicationStatus !== null &&
      values.videoKycDTO.applicationStatus !== undefined && (
        values.videoKycDTO.applicationStatus.toLowerCase() === VideoKYCStatusEnum.Verified.toLowerCase() ||
        values.videoKycDTO.applicationStatus.toLowerCase() === VideoKYCStatusEnum.Rejected.toLowerCase())
    ) {
      setReviwerStatus(values.videoKycDTO.applicationStatus);
    } else {
      setReviwerStatus(VideoKYCStatusEnum.Pending)
    }

  }, []);

  function createProfile() {
    // only create profile if the video kyc url is null in the video kyc dto
    // this gets triggered if the video kyc has not been initiated at all
    if (videoKycUrl && videoKycUrl !== "") {
      openVideoKyc(videoKycUrl);
    } else {
      let videoKycCreateProfileDTO = {
        kycSessionToken : sessionStorage.getItem(SessionKeyEnum.AppKey),
        holderType : applicationContext.currentHolder.entityTypeName,
        aadharFaceImagePath : values.personalInfoDTO.keyPersonalInfoDTO.aadhaarFaceImageUrl
      };
      videoKycCreateProfile(videoKycCreateProfileDTO ).then(
        (res) => {
          if (res !== null && res !== "") {

            // set details
            setVideoKYCDTO(res);

            setVideoKycUrl(res.url);
            // open the video kyc if capture link is received
            openVideoKyc(res.url);

          }
          else{
            setClicked(false);
          }
          
        },
        (error) => {
          setClicked(false);
        }
      );
    }
  }

  function getVideoKycDetails(e) {
    e.preventDefault();

    if (clicked === false) {
      setClicked(true);

       //validate date for video kyc
      validateDateForVideoKyc(
        sessionStorage.getItem(SessionKeyEnum.KycApplicationId),
        applicationContext.currentHolder.entityTypeName
      ).then(
        (res) => {
         if(res.isValid){
          //video kyc create profile
             createProfile();

         }
         else{
          if(res.errorMessage == VideoKycErrorTypeEnum.aadharNotUploaded){
            setAlertMsg(t("videoKyc.getYourAadharDetails"));
            setClicked(false);
            setIsOpenAlertMsg(true);
           // moveToKeyPersonalInfoWidget();       
          }
          else if(res.errorMessage == VideoKycErrorTypeEnum.aadharUploadedDateExceeds){
            setAlertMsg(t("videoKyc.aadhaarDetailsExpired"));
            setClicked(false);
            setIsOpenAlertMsg(true);           
          }
          else{
            setClicked(false);
          }
         }
        },
        (error) => {
          setClicked(false);
        }
      );   
    }
  }

  function onClosingAlertModel(value){
       if(alertMsg === t("videoKyc.getYourAadharDetails")){
        moveToKeyPersonalInfoWidget();
       }
       else if(alertMsg === t("videoKyc.aadhaarDetailsExpired")){
        setClicked(true);
        removePersonalInfo();
       }

  }

  function removePersonalInfo(){
    removePersonalInfoData(
      sessionStorage.getItem(SessionKeyEnum.KycApplicationId),
      applicationContext.currentHolder.entityTypeName
    ).then(
      (res) =>{
               
        setClicked(false); 
        props.moveToWidget(res);
      },
      (error) =>{
        setClicked(false); 
      }
    );
  }
  function moveToKeyPersonalInfoWidget(){
    props.moveNextWidgetByName(WidgetEnum.PERSONALINFO);    
  }

  function getProfileStatus() {
    videoKycProfileStatus(
      videoKYCDTO.profileId,
      applicationContext.currentHolder.entityTypeName,
      sessionStorage.getItem(SessionKeyEnum.AppKey)
    ).then(
      (res) => {
        if(res && res.widgetDTO && res.widgetDTO.status.toLowerCase() !== VideoKYCStatusEnum.Pending.toLowerCase() ){
          updateWidgetStatus(res);
        }
        setProfileStatusClicked(false);
      },
      (error) => {
        setProfileStatusClicked(false);
      }
    );
  }
  
  function getVideoKYCProfileDetails(e) {
    if (profileStatusClicked === false) {
      setProfileStatusClicked(true);

      e.preventDefault();

      //video kyc profile status
      getProfileStatus();
    }
  }

  function showGetVideoKYCProfile(){
    return !isDisabled && videoKycUrl && showVideoKycLink;
  }

  //Styles added  depend on reviewerStatus
  /* For Container */
  function getClassNameByStatus() {
    if (reviewerStatus.toLowerCase() === VideoKYCStatusEnum.Verified.toLowerCase())
      return styles.status_approved_container;
  else if (reviewerStatus.toLowerCase() === VideoKYCStatusEnum.Rejected.toLowerCase())
      return styles.status_rejected_container;
  else
      return styles.status_pending_container;
  }

  /* For Buttons */
  function getStatusActionByStatus() {   
   if (reviewerStatus.toLowerCase() === VideoKYCStatusEnum.Verified.toLowerCase())
      return styles.status_btn_approved ;
  else if (reviewerStatus.toLowerCase() === VideoKYCStatusEnum.Rejected.toLowerCase())
      return styles.status_btn_rejected ;
  else
      return styles.status_btn_pending ;
  }

 
  return (
    <div className="container">
      {/* View Mode */}
       <div className={styles.video_kyc_body}>
       {!(formMode === VIEW_MODE) && (
        <div className={getClassNameByStatus()}>
          {/*videoKyc title */}
          <div className={styles.video_kyc_title}>
            <span className="mb-2">
              <CsplLabel label={"videoKyc.videoKYC"} ></CsplLabel>
            </span>
            <span className="mb-2">
              <button className={getStatusActionByStatus()} onClick={(e) => e.preventDefault()}>
                {reviewerStatus}
                </button>
            </span>
            {
              videoKYCDTO &&
              videoKYCDTO.rejectionRemarks !== null &&
              videoKYCDTO.rejectionRemarks !== undefined && reviewerStatus.toLowerCase() === VideoKYCStatusEnum.Rejected.toLowerCase()&& 
                <span className={styles.rejection_remarks}>
                  {videoKYCDTO.rejectionRemarks}
                </span>
            }     

{/* Verified */}
            <span className={styles.status_approved_instruction}>
            {reviewerStatus.toLowerCase() === VideoKYCStatusEnum.Verified.toLowerCase() ? (t("videoKyc.videoKycApprovedText")) : false}
            </span>
            
          </div>

          <div className="aadhaar-xml-link d-flex flex-column">
            {!(formMode === VIEW_MODE) && showVideoKycLink && (
              <a onClick={(e) => getVideoKycDetails(e)} className="btn shadow-none aadhaar-xml-btn ">
                <CsplLabel label="videoKyc.createProfileText"></CsplLabel>
              </a>
            )} 
            {clicked &&
             <CsplBackDropLoading showLoading={clicked}></CsplBackDropLoading> }
          </div>

             <AlertModal
                        isModalOpen={isOpenAlertMsg}
                        setIsModalOpen={setIsOpenAlertMsg}
                        modalWidth={StylePropertiesEnum.sm}
                        title={"AddressChange.alert"}
                        businessProcess={onClosingAlertModel}
                        type={StylePropertiesEnum.OKCANCEL}
                      >
                        {alertMsg}
            </AlertModal>
        </div>
        )} 
      </div> 

       {/* Form Mode */}
      <div className={styles.video_kyc_content_header}>

      
          { formMode === VIEW_MODE  &&  values && values.videoKycDTO &&
           reviewerStatus.toLowerCase() !== VideoKYCStatusEnum.Pending.toLowerCase()&& (
            <>
          <div className="ms-1">
            <span className="mb-2 me-3">
              <CsplLabel label={"videoKyc.videoKYC"} ></CsplLabel>
            </span>
            <span className="mb-4">
              <button className={getStatusActionByStatus()} onClick={(e) => e.preventDefault()}>{reviewerStatus}</button>
            </span>
          </div>

              <div className={styles.video_kyc_content}>
                <div>
                  <span className={styles.header}>
                    <CsplLabel label={"videoKyc.geoLocation"}></CsplLabel>
                  </span>
                </div>
                <br />
                <div className={styles.table_content}>
                  <table className="table table-striped table-bordered border-white table-responsive">
                    <tbody className={styles.table_alternate_color}>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel
                            label={"videoKyc.locationAccuracy"}
                          ></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationAccuracy}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel
                            label={"videoKyc.locationAccuracyLevel"}
                          ></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationAccuracyLevel}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel label={"videoKyc.city"}></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationCity}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel label={"videoKyc.country"}></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationCountry}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel label={"videoKyc.district"}></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationDistrict}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel label={"videoKyc.pincode"}></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationPincode}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel label={"videoKyc.state"}></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationState}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel label={"videoKyc.streetAddress"}></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationStreetAddress}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel label={"videoKyc.latitude"}></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationLatitude}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel label={"videoKyc.longitude"}></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.locationLongitude}</td>
                      </tr>
                      <tr>
                        <th scope="row" className={styles.table_header}>
                          <CsplLabel label={"videoKyc.ipAddress"}></CsplLabel>
                        </th>
                        <td>{values.videoKycDTO.publicIpOfInvestor}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className={styles.video_kyc_content}>
                <div>
                  <span className={styles.header}>
                    <CsplLabel label={"videoKyc.securityChecks"}></CsplLabel>
                  </span>
                </div>
                <br />
                <div>
                  <CsplAccordion
                    List={values.videoKycDTO.securityQuestionDTOList}
                  />
                </div>
              </div>

              <div className={styles.video_kyc_content}>
                <div>
                  <span className={styles.header}>
                    <CsplLabel label={"videoKyc.videoCaptured"}></CsplLabel>
                  </span>
                </div>
                <br />
                <div className="container card border-0 padding-left-0">
                  <div className="row">
                    {values.videoKycDTO.videos.map((list) => (
                      <div className="col-xl-3 col-lg-4 col-md-6 col-sm-5 col-11">
                        <CsplVideoComponent
                          Title={list.videoAttribute}
                          img={
                            "https://media.istockphoto.com/photos/solution-concepts-new-year-2020-on-chalkboard-background-picture-id1195447776?s=612x612"
                          }
                          srcURl={list.videoUrl}
                          helperText={"videoKyc.playMessage"}
                          logo={
                            "https://media.istockphoto.com/photos/solution-concepts-new-year-2020-on-chalkboard-background-picture-id1195447776?s=612x612"
                          }
                          holderType = {applicationContext.currentHolder.entityTypeShortName}
                          localServerPath = {list.localServerPath}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className={styles.video_kyc_content}>
                <div>
                  <span className={styles.header}>
                    <CsplLabel label={"videoKyc.imagesCaptured"}></CsplLabel>
                  </span>
                </div>
                <br />
                <div className="row">
                  {values.videoKycDTO.imageDetails.map((list) => {         
                      return (
                        <div className="col-md-5 col-lg-5 col-xl-4 col-xxl-3 col-sm-5">
                          <CsplCard imgUrl={list.imageUrl} imgType={list.imageType} localServerPath = {list.localServerPath}/>
                        </div>
                      )                  
                  })}
                </div>
              </div>

              <div className={styles.video_kyc_content}>
                <div>
                  <span className={styles.header}>
                    <CsplLabel label={"videoKyc.faceCheck"}></CsplLabel>
                  </span>
                </div>
                <br />
                <div className="container border-0 padding-left-15">
                  <div className="row">
                    <FaceCheckComponent
                      List={values.videoKycDTO.faceCompareDTOList}
                      passLabel={"videoKyc.pass"}
                      failLabel={"videoKyc.fail"}
                      remarksLabel={"videoKyc.remarks"}
                      vsLabel={"videoKyc.vs"}
                    ></FaceCheckComponent>
                  </div>
                </div>
              </div>
            </>
          )}
      </div>
      
    </div>
  );
}

export default VideoKyc;
